<template>
  <b-container fluid class="liquidation-page">
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="12" md="5" lg="3">
              <label>Data Inicial</label>
              <b-form-input type="date" v-model="startDate" size="md" />
            </b-col>

            <b-col cols="12" md="5" lg="3">
              <label>Data Final</label>
              <b-form-input type="date" v-model="endDate" size="md" />
            </b-col>
            <b-col cols="12" md="2" lg="2">
          <b-button
            variant="primary"
            class="w-100 mt-2"
            @click="loadHistory"
            :disabled="isLoading"
          >
            Buscar
          </b-button>
        </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card>
          <upload-buttons :loading="loading" @upload="handleUpload" />
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card>
          <upload-history
            :history="history"
            :is-loading="isLoading"
            :no-data-message="noDataMessage"
          />
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BButton,
  BFormInput,
} from "bootstrap-vue";

import UploadHistory from "./UploadHistory.vue";
import UploadButtons from "./UploadButtons.vue";
import LiquidationService from "@/service/liquidation-archives";

export default {
  name: "LiquidationArchives",

  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BButton,
    BFormInput,
    UploadHistory,
    UploadButtons,
  },

  data() {
    return {
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      history: [],
      isLoading: false,
      loading: null,
      noDataMessage: "",
    };
  },

  mounted() {
    this.loadHistory();
  },

  methods: {
    async loadHistory() {
      if (!this.startDate || !this.endDate) return;

      this.isLoading = true;
      this.noDataMessage = "";

      try {
        const response = await LiquidationService.getUploadHistory({
          initialDate: this.startDate,
          finalDate: this.endDate,
        });

        this.history = Array.isArray(response.data) ? response.data : [];

        if (this.history.length === 0) {
          this.noDataMessage = "Nenhum registro encontrado";
          this.$toast.warning(this.noDataMessage);
        } else {
          this.$toast.success("Histórico carregado!");
        }
      } catch (err) {
      console.error(err);

      if (err.response.status === 400) {
        this.history = [];
        this.noDataMessage = err.response.data.message || "Nenhum dado encontrado";
        this.$toast.warning(this.noDataMessage);
      } else {
        this.noDataMessage = "Erro ao buscar histórico";
        this.$toast.error(this.noDataMessage);
      }
    } finally {
        this.isLoading = false;
      }
    },

    async handleUpload(type) {
      if (!this.startDate || !this.endDate) {
        this.$toast.warning("Selecione o período");
        return;
      }

      this.loading = type;

      const payload = {
        initialDate: this.startDate,
        finalDate: this.endDate,
      };

      const actions = {
        arquivos: (payload) => LiquidationService.sendArquivos(payload),
        polishop: (payload) => LiquidationService.sendPolishop(payload),
        equals: (payload) => LiquidationService.sendEquals(payload),
        boaVista: (payload) => LiquidationService.sendBoaVista(payload),
      };

      try {
        if (!actions[type]) {
          throw new Error(`Tipo de envio inválido: ${type}`);
        }

        await actions[type](payload);

        this.$toast.success("Arquivo enviado com sucesso!");

        await this.loadHistory();
      } catch (err) {
        console.error(err);
        this.$toast.error("Erro ao enviar arquivo");
      } finally {
        this.loading = null;
      }
    },
  },
};
</script>